import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface InitialStateType {
  newPatient?: boolean;
  patientWithoutCoverage?: number;
  patientDocument?: string;
  patientDocumentType?: string;
}

const initialState: InitialStateType = {
  newPatient: false,
  patientWithoutCoverage: -1,
  patientDocument: '',
  patientDocumentType: ''
};

export const ValidationViewState = createSlice({
  name: "ValidationView",
  initialState,
  reducers: {
    setNewPatient: (state, action: PayloadAction<boolean>) => {
      state.newPatient = action.payload;
    },
    setPatientWithoutCoverage: (state, action: PayloadAction<number>) => {
      state.patientWithoutCoverage = action.payload;
    },
    setPatientDocument: (state, action: PayloadAction<string>) => {
      state.patientDocument = action.payload;
    },
    setPatientDocumentType: (state, action: PayloadAction<string>) => {
      state.patientDocumentType = action.payload;
    },
    resetFieldsValidation: () => {
      return { ...initialState };
    }
  }
});

export const { setNewPatient, resetFieldsValidation, setPatientWithoutCoverage, setPatientDocument, setPatientDocumentType } = ValidationViewState.actions;

export default ValidationViewState.reducer;

